import {
    BreachScreenType,
    click_origin_breach_screen_inline,
} from '@news-mono/web-common'
import React from 'react'
import { ButtonLink } from '../../../../buttons/ButtonLink/ButtonLink'
import { useAuthActions } from '../../../../user-registration/authentication/AuthenticationProvider'
import { createLinkClickEvent } from '../../createLinkClickHandler'
import {
    StyledCallToAction,
    StyledCallToActionDescription,
    StyledCallToActionDescriptionText,
    StyledCallToActionDetails,
    StyledCallToActionSubtitle,
    StyledCallToActionSubtitleText,
    StyledCallToActionTitle,
    StyledHiddenSpans,
    StyledPlusImage,
    StyledSaveIcon,
    StyledSubscribeButton,
    StyledSubscriberLogin,
    StyledTAndCs,
} from './SportBreachCallToAction.styled'

const saveIconFile = require('../../assets/save46.png')
const plusIconFile = require('../../assets/plus.png')

export interface SportBreachCallToActionProps {
    isLoggedIn: boolean
    onEvent: (event: any) => void
    breachCreativeName: string
    breachDeal: string
    articleId: string
    leadDepth: number
}

export const SportBreachCallToAction: React.FC<SportBreachCallToActionProps> =
    ({ isLoggedIn, onEvent, breachCreativeName, breachDeal, leadDepth }) => {
        const { onLoginClick, onSubscribeClick } = useAuthActions()

        return isLoggedIn ? null : (
            <StyledCallToAction>
                <StyledCallToActionDetails>
                    <StyledSaveIcon src={saveIconFile} />
                    <StyledCallToActionTitle>
                        Don't miss the latest sports news!
                    </StyledCallToActionTitle>
                    <StyledCallToActionSubtitle>
                        <StyledCallToActionSubtitleText strikethrough>
                            <StyledHiddenSpans>Was </StyledHiddenSpans>
                            $13
                            <StyledHiddenSpans> now</StyledHiddenSpans>
                        </StyledCallToActionSubtitleText>{' '}
                        <StyledCallToActionSubtitleText bold>
                            $7
                        </StyledCallToActionSubtitleText>{' '}
                        <StyledCallToActionSubtitleText>
                            per week for 12 weeks* (Digital + Print)
                        </StyledCallToActionSubtitleText>
                    </StyledCallToActionSubtitle>
                </StyledCallToActionDetails>
                <StyledCallToActionDescription>
                    <StyledCallToActionDescriptionText>
                        Enjoy unlimited access to thewest.com.au and everyday
                        digital editions on any device.
                    </StyledCallToActionDescriptionText>
                    <StyledCallToActionDescriptionText>
                        <StyledPlusImage
                            src={plusIconFile}
                            alt="Plus"
                        ></StyledPlusImage>{' '}
                        Thursday - Monday papers home delivered with all of the
                        latest footy news!
                    </StyledCallToActionDescriptionText>
                </StyledCallToActionDescription>
                <StyledSubscribeButton
                    type={'button'}
                    onClick={() => {
                        const breachScreenType: BreachScreenType =
                            'Premium - Inline - Promo'

                        createLinkClickEvent(
                            breachCreativeName,
                            breachDeal,
                            onEvent,
                            breachScreenType,
                            leadDepth,
                        )()
                        onSubscribeClick({
                            offerCode: 'SPORT20',
                            callToAction: click_origin_breach_screen_inline,
                            breachScreenType: breachScreenType,
                        })
                    }}
                >
                    Subscribe now
                </StyledSubscribeButton>
                <StyledSubscriberLogin>
                    Already a Subscriber?{' '}
                    <ButtonLink
                        onClick={() => onLoginClick('sports-breach-screen')}
                    >
                        Log in
                    </ButtonLink>
                </StyledSubscriberLogin>
                <StyledTAndCs>*T&Cs apply</StyledTAndCs>
            </StyledCallToAction>
        )
    }
SportBreachCallToAction.displayName = 'SportBreachCallToAction'

export default SportBreachCallToAction
